import { Vue, Watch, Prop, Component } from 'vue-property-decorator';
import NewDistributionList from './newDistributionList';
import NewDistributionEdit from './newDistributionEdit';
import { IPSService } from '@/services/ipsServices';

@Component({
  components: { NewDistributionList, NewDistributionEdit },
})
export default class NewDistributionConfig extends Vue {
  // 列表或者编辑 1 列表 2 编辑
  listOrEdit = 1;

  // 详情界面是否禁用
  disabled = false;

  // 策略Id
  policyId = 0;

  @Prop()
    sgId;

  @Prop()
    modeType;

  policyType = 0;

  policyPattern = 0;

  policyState = 0;

  maxCommission = 0;

  @Prop()
    empCode;

  async mounted() {
    this.maxCommission = await this.getMaxCommission();
  }

  onConfig(val, policyId, disabled, policyType, policyPattern, policyState) {
    this.listOrEdit = val;
    this.disabled = disabled;
    this.policyId = policyId;
    this.policyType = policyType;
    this.policyPattern = policyPattern;
    this.policyState = policyState;
  }

  getMaxCommission() {
    return IPSService.getVGuiderBaseConfig().then((res) => {
      return res.maxCommission / 100;
    });
  }

  render(h) {
    return this.listOrEdit === 1 ? (
      <NewDistributionList onConfig={this.onConfig.bind(this)} sgId={this.sgId} modeType={this.modeType} empCode={this.empCode} />
    ) : (
      <NewDistributionEdit
        empCode={this.empCode}
        policyState={this.policyState}
        disabled={this.disabled}
        modeType={this.modeType}
        sgId={this.sgId}
        policyType={this.policyType}
        policyPattern={this.policyPattern}
        policyId={this.policyId}
        onGoBack={() => (this.listOrEdit = 1)}
        maxCommission={this.maxCommission}
      />
    );
  }
}
